import { ChangeDetectionStrategy, Component, Input, OnInit, signal, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-link-button',
    imports: [MatIconModule],
    templateUrl: './formly-link-button.component.html',
    styleUrl: './formly-link-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyLinkButtonComponent extends FieldType implements OnInit {
    link: string;
    icon: string;

    ngOnInit(): void {
        this.link = this.formControl.value;
        this.icon = this.field.props.icon;
    }

    onClick(): void {
        window.open(this.link, '_blank');
    }
}
